export default {"src":"/_next/static/media/exemptions-animation-white.e8686793.gif","height":1180,"width":1200,"blurWidth":0,"blurHeight":0};